import React, { useEffect, useState } from 'react';
import { axiosInstance, getCurrentUser } from './axiosInstance';
import { hostUrl } from './config';
import Header from './Header';

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const username = getCurrentUser();
        if (!username) {
          setError('Unable to determine current user.');
          setLoading(false);
          return;
        }
        const response = await axiosInstance.get(`${hostUrl}/custom_user/?format=json&search=${encodeURIComponent(username)}`);
        const user = response.data?.results?.[0];
        if (!user) {
          setError('Profile not found.');
        } else {
          setProfile(user);
        }
      } catch (err) {
        setError(err.response?.data?.detail || err.message || 'Failed to load profile.');
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handlePasswordReset = async () => {
    setMessage('');
    setError('');
    const email = profile?.email;
    if (!email) {
      setError('Email is missing for this user.');
      return;
    }

    try {
      const response = await axiosInstance.post(`${hostUrl}/password-reset/`, { email });
      setMessage(response.data?.detail || 'If the email exists, a reset link has been sent.');
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'Failed to send reset email.');
    }
  };

  const displayName = profile?.name || `${profile?.first_name || ''} ${profile?.last_name || ''}`.trim() || '—';
  const displayUsername = profile?.usernames || getCurrentUser() || '—';
  const displayEmail = profile?.email || '—';

  return (
    <div className="d-flex flex-row">
      <Header />
      <main style={{ marginTop: '70px' }} className="flex-grow-1">
        <div className="container mt-4">
          <h2 className="mb-4">Profile</h2>

          {loading && <div>Loading...</div>}
          {error && <div className="alert alert-danger">{error}</div>}
          {message && <div className="alert alert-success">{message}</div>}

          {!loading && !error && (
            <div className="card p-4">
              <div className="mb-3">
                <div className="text-muted">Name</div>
                <div className="h5">{displayName}</div>
              </div>
              <div className="mb-3">
                <div className="text-muted">Username</div>
                <div className="h5">{displayUsername}</div>
              </div>
              <div className="mb-3">
                <div className="text-muted">Email</div>
                <div className="h5">{displayEmail}</div>
              </div>

              <div className="mt-3">
                <button className="btn btn-outline-primary" onClick={handlePasswordReset}>
                  Send Password Reset Email
                </button>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Profile;
